import bootbox from 'bootbox';
import Sortable from 'sortablejs';

$(document).ready(function()
{
  if ($("#btnSettingsUsersInvite").length === 0) return;

  $("#btnSettingsUsersInvite").on("click", function()
  {
    let $frm = $('<form>' +
      '<div class="form-group">' +
        '<label for="txtModalEmail">' + App.Lang.get('email') + '</label>' +
        '<input type="email" name="email" class="form-control" id="txtModalEmail" placeholder="' + App.Lang.get('email') + '" required maxlength="191" />' +
      '</div>' +
      '<div class="form-group">' +
        '<label for="txtModalName">' + App.Lang.get('name') + '</label>' +
        '<input type="text" name="name" class="form-control" id="txtModalName" placeholder="' + App.Lang.get('name') + '" required maxlength="200" />' +
      '</div>' +
    '</form>');
    
    var dialog = bootbox.dialog(
    {
      title: App.Lang.get('add_new_user'),
      message: $frm,
      buttons:
      {
        cancel:
        {
          label: App.Lang.get('cancel'),
          className: 'btn-secondary'
        },
        ok:
        {
          label: App.Lang.get('invite'),
          className: 'btn-primary',
          callback: function(event)
          {
            var $btn = $(event.target);

            if ($frm.valid())
            {
              var functionParams =
              {
                email: $frm.find("#txtModalEmail").val(),
                name: $frm.find("#txtModalName").val()
              };

              var ajaxParams = 
              {
                sourceEl: $btn,
                effectTarget: $btn,
                onSuccess: function(response)
                {
                  dialog.modal('hide');
                  bootbox.alert(response.message, function()
                  {
                    window.location.reload();
                  });
                }
              };

              App.Helper.ajaxCall("invite_users", functionParams, ajaxParams);
            }
            
            return false;
          }
        }
      }
    });
  });
  
  $("#btnSettingsUsersSave").on("click", function()
  {
    var $btn = $(this);
    
    var functionParams =
    {
      data: $("#tblSettingsUsers :input").serialize()
    };

    var ajaxParams = 
    {
      sourceEl: $btn,
      effectTarget: $btn
    };

    App.Helper.ajaxCall("save_users", functionParams, ajaxParams);
  });

});
